import { Button, Form, Modal, Tooltip, message } from 'antd';
import React, { useEffect, useState } from 'react';
import StAddNew from './DSeries/StAddNew';
import StablePrime from '../components/Tables/StablePrime';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import { DeleteOutlined, EditOutlined, PlusCircleFilled } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import ZenModal from '../components/ZenModal';


const StableBuilder = ({
    setPageHeader
}) => {
    const urlCode = useSelector(state => state.urlCode);
    const [dictForm] = Form.useForm();
    const [pageConfigData, setPageConfigData] = useState();
    const [elementLoading, setElementLoading] = useState(true);
    const [modalTitle, setModalTitle] = useState('');
    const stableDictNames = {
        'add-column': 'StableBuilder_addNew',
        'edit-column': 'StableBuilder_addNew',
        'edit-tableConfig': 'StableBuilder_tblConfig',
        'edit-tableTitle': 'StableBuilder_tableTitle',
        'edit-tableSubTitle': 'StableBuilder_tableSubTitle',
        'edit-zenFuncs': 'StableBuilder_zenfuncs',
        'add-headerMultilineSingle': 'StableBuilder_multiLineSingleCol',
        'add-footerMultilineSingle': 'StableBuilder_multiLineSingleCol',
        'edit-footerMultilineSingle': 'StableBuilder_multiLineSingleCol',
        'edit-headerMultilineSingle': 'StableBuilder_multiLineSingleCol',
        'edit-footer': 'StableBuilder_footer',
        'upload-json': 'ZenFormBuilder_jsonUploader',
        'add-footer-btn': 'ZenFormBuilder_footerBtns',
        'add-rat': 'addRatButton',
        'add-hat': 'addHatButton',
    }
    const zenPop = {
        "addRat": {
            "typ": "smodal",
            "api": "/smodal",
            "params": {
                "dictName": "addRatButton"
            },
            "title": "Add Row Action (Rat)",
            "width": 500
        },
        "addHat": {
            "typ": "smodal",
            "api": "/smodal",
            "params": {
                "dictName": "addHatButton"
            },
            "title": "Add ZenPop (Hat)",
            "width": 500
        },
    }
    const [zenModal, setZenModal] = useState();
    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "",
        data: undefined,
        show: false,
        loading: false,
    });
    const toggleModal = ({ show = false, data = undefined, type = "", loading = false }) => {
        setModal({ show, data, type, loading });
    }

    const [modalData, setModalData] = useState({
        open: false,
        typ: '',
        data: null,
        loading: false
    });

    const openSmodal = (zenPop) => {
        setZenModal(zenPop);
        let urlData = { ...zenPop?.params };
        return toggleModal({
            show: true,
            data: {
                urlData: { ...dictForm.getFieldsValue(), ...urlData }
            },
            type: 'smodal',
            loading: false
        });
    }


    useEffect(() => {
        setPageHeader('Stable Builder');
    }, []);

    const openModal = ({ typ, data }) => {
        setElementLoading(false);
        setModalData({
            open: true,
            typ,
            data
        })
    };

    const addFooterBtn = (values) => {
        let configData = { ...pageConfigData };
        delete values.p_type
        let footerBtns = { ...pageConfigData?.config?.footerButtons };
        let footerBtnName = Object.keys(footerBtns);
        if (footerBtnName.length) {
            let lastBtn = footerBtnName[footerBtnName.length - 1]
            lastBtn = parseInt(lastBtn.split('button')[1]) + 1;
            footerBtns[`button${lastBtn}`] = {
                buttonProp:
                    values
            }
        } else {
            footerBtns['button1'] = {
                buttonProp:
                    values
            }
        };
        configData.config.footerButtons = footerBtns;
        return saveFullQuery({ pageConfig: configData });
    }

    const closeModal = () => {
        setElementLoading(true);
        setModalTitle(undefined);
        setTimeout(() => {
            setModalData({
                open: false,
                data: null,
                typ: '',
                loading: false
            })
        }, 20);
    };

    const saveQuery = ({
        columns,
        tableConfig,
        tableTitle,
        tableSubTitle,
        resolve = () => { },
        reject = () => { }
    }) => {
        let configData = { ...pageConfigData };
        if (columns) {
            configData.config.column = columns;
        };
        if (tableConfig) {
            configData.config.tableConfig = tableConfig;
        }
        if (tableTitle) {
            configData.config.tableTitle = tableTitle;
        }
        if (tableSubTitle) {
            configData.config.tableSubTitle = tableSubTitle;
        }
        liracrypt.patch('/zenformstablebuilder', configData)
            .then(({ data }) => {
                if (data.isSuccess) {
                    //     message.success('Saved Successfully');
                    closeModal();
                    dictForm.submit();
                    resolve();
                } else {
                    message.error('Error');
                    resolve();
                }
            })
            .catch(err => {
                console.log(err);
                resolve();
                ApiErrorComp()
            })
    }
    const saveFullQuery = ({
        pageConfig,
        resolve = () => { },
        reject = () => { }
    }) => {
        liracrypt.patch('/zenformstablebuilder', { ...pageConfig })
            .then(({ data }) => {
                if (data.isSuccess) {
                    closeModal();
                    dictForm.submit();
                    resolve();
                } else {
                    message.error('Error');
                    resolve();
                }
            })
            .catch(err => {
                console.log(err);
                resolve();
                ApiErrorComp()
            })
    }

    const addColumn = (values) => {
        let pageData = { ...pageConfigData };
        Object.keys(values).forEach(x => {
            if (values[x] === 'true') {
                values[x] = true;
            }
            if (values[x] === 'false') {
                values[x] = false;
            }
        })
        let columns = [...pageData.config.column, values];
        saveQuery({ columns });
    };
    const editTableConfig = (values) => {
        let tableConfig = { ...pageConfigData.config.tableConfig };
        Object.keys(values).forEach(x => {
            if (values[x] === 'true') {
                values[x] = true;
            }
            if (values[x] === 'false') {
                values[x] = false;
            }
        })
        tableConfig = { ...tableConfig, ...values };
        saveQuery({ tableConfig });
    };
    const editTableTitle = (values) => {
        let tableTitle = { ...pageConfigData.config.tableTitle };
        tableTitle = { ...tableTitle, ...values };
        saveQuery({ tableTitle });
    };
    const editTableSubTitle = (values) => {
        let tableSubTitle = { ...pageConfigData.config.tableSubTitle };
        tableSubTitle = { ...tableSubTitle, ...values };
        saveQuery({ tableSubTitle });
    };

    const editZenFuncs = (values) => {
        let configData = { ...pageConfigData };
        configData.config.zenFuncs = values;
        saveFullQuery({ pageConfig: configData })
    };

    const editFooter = (values) => {
        let configData = { ...pageConfigData };
        configData.config.footer = values;
        saveFullQuery({ pageConfig: configData })
    };

    const editColumn = (values, indx) => {
        let listIndx = indx?.toString() || modalData.data.listIndx
        //   setSmodalLoading(false);
        let columns = [...pageConfigData.config.column];
        let index = columns.findIndex((_, i) => i === parseInt(listIndx));
        columns[index] = values;
        saveQuery({ columns });
    }

    const deleteColumn = (indx) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this column?',
            okButtonProps: { danger: true },
            okText: 'Yes',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    let columns = [...pageConfigData.config.column];
                    columns = columns.filter((_, i) => i !== indx);
                    saveQuery({ columns, resolve, reject });
                })
            }
        })
    };

    const addMultiLineSingle = (values) => {
        let configData = { ...pageConfigData };
        if (modalData.typ === 'add-headerMultilineSingle') {
            let headerData = { ...configData.config.headerMultiline };
            if (headerData.singleCol?.length) {
                headerData.singleCol = [...headerData.singleCol, values];
            } else {
                headerData.singleCol = [values];
            }
            configData.config.headerMultiline = headerData;
        };
        if (modalData.typ === 'add-footerMultilineSingle') {
            let footerData = { ...configData.config.footerMultiline };
            if (footerData.singleCol?.length) {
                footerData.singleCol = [...footerData.singleCol, values];
            } else {
                footerData.singleCol = [values];
            }
            configData.config.footerMultiline = footerData;
        };
        saveFullQuery({ pageConfig: configData })
    };


    const editMultiLineSingle = (values, indx) => {
        let configData = { ...pageConfigData };
        if (modalData.typ === 'edit-headerMultilineSingle') {
            let headerData = { ...configData.config.headerMultiline };
            headerData.singleCol[indx] = values;
            configData.config.headerMultiline = headerData;
        };
        if (modalData.typ === 'edit-footerMultilineSingle') {
            let footerData = { ...configData.config.footerMultiline };
            footerData.singleCol[indx] = values;
            configData.config.footerMultiline = footerData;
        };
        saveFullQuery({ pageConfig: configData })
    };


    const deleteSingleCol = (indx, typ) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this line?',
            okButtonProps: { danger: true },
            okText: 'Yes',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    let configData = { ...pageConfigData };
                    if (typ === 'header') {
                        let headerData = { ...configData.config.headerMultiline };
                        let singleColList = [...headerData.singleCol];
                        headerData.singleCol = singleColList.filter((_, i) => i !== indx);
                        configData.config.headerMultiline = headerData;
                    }
                    if (typ === 'footer') {
                        let footerData = { ...configData.config.footerMultiline };
                        let singleColList = [...footerData.singleCol];
                        footerData.singleCol = singleColList.filter((_, i) => i !== indx)
                        configData.config.footerMultiline = footerData;
                    }
                    saveQuery({ pageConfig: configData, resolve, reject });
                })
            }
        })
    }

    const downloadJson = () => {
        liracrypt.get('/pageconfig/download', { typ1: 'stable', dictName: pageConfigData?.config?.dictName, pageconfigId: pageConfigData?.config?.pageconfigId }).then(({ data }) => {
            if (data.isSuccess) {
                window.open(
                    `${process.env.REACT_APP_API_ENDPOINT}/fetchfilesingleattachmentzenform?filePath=${data.data.filePath}&fileName=${data.data.fileName}&token=${localStorage.getItem("token")}&urlCode=${urlCode}`,
                    '_blank'
                )
            } else {
                message.error(data.message);
            }
        })
    }

    const addRat = async () => {
        let response;
        response = await liracrypt.patch()
    }

    const onModalSubmit = (values) => {
        setModalData({
            ...modalData,
            loading: true
        });
        Object.keys(values).forEach(x => {
            if (values[x] === 'true') {
                values[x] = true;
            }
            if (values[x] === 'false') {
                values[x] = false;
            }
        })
        if (modalData.typ === 'add-column') {
            return addColumn(values);
        }
        if (modalData.typ === 'add-footer-btn') {
            return addFooterBtn(values);
        }
        if (modalData.typ === 'add-rat') {
            return addFooterBtn(values);
        }
        if (modalData.typ === 'add-hat') {
            return addFooterBtn(values);
        }
        if (modalData.typ === 'edit-column') {
            return editColumn(values, modalData.data.zenPreviewListIndex)
        }
        if (modalData.typ === 'edit-tableConfig') {
            return editTableConfig(values)
        }
        if (modalData.typ === 'edit-tableTitle') {
            return editTableTitle(values)
        }
        if (modalData.typ === 'edit-tableSubTitle') {
            return editTableSubTitle(values)
        }
        if (modalData.typ === 'edit-footer') {
            return editFooter(values)
        }
        if (modalData.typ === 'edit-zenFuncs') {
            return editZenFuncs(values);
        }
        if (modalData.typ === 'upload-json') {
            return onJsonUpload(values);
        }
        if (modalData.typ === 'add-headerMultilineSingle' || modalData.typ === 'add-footerMultilineSingle') {
            values.style = {
                "fontFamily": "Arial",
                "fontWeight": "800",
                "fontSize": "22px",
                "color": "#bebebe",
                "textAlign": "left",
                "margin": "1px 1px 10px 1px"
            };
            return addMultiLineSingle(values);
        }
        if (modalData.typ === 'edit-headerMultilineSingle' || modalData.typ === 'edit-footerMultilineSingle') {
            values.style = {
                "fontFamily": "Arial",
                "fontWeight": "800",
                "fontSize": "22px",
                "color": "#bebebe",
                "textAlign": "left",
                "margin": "1px 1px 10px 1px"
            };
            return editMultiLineSingle(values, modalData.data.zenPreviewListIndex);
        }
    };

    const onJsonUpload = (values) => {
        // setSmodalLoading(true);
        let formData = new FormData();
        formData.append('dictName', pageConfigData?.config?.dictName);
        formData.append('pageconfigId', pageConfigData?.config?.pageconfigId);
        formData.append('typ1', 'stable');
        Object.keys(values).forEach(x => {
            formData.append(x, values[x]);
        });
        let dictFormData = dictForm.getFieldsValue();
        Object.keys(dictFormData).forEach(x => {
            formData.append(x, dictFormData[x]);
        });
        liracrypt.uploadFile('/pageconfig/upload', formData)
            .then(({ data }) => {
                console.log(data);
                // setSmodalLoading(false);
                if (data.isSuccess) {
                    dictForm.submit();
                    closeModal();
                    //    message.success(data.message || 'Successfully Saved');
                } else {
                    message.success(data.message || 'Something went wrong');
                }
            }).catch(err => {
                //  setSmodalLoading(false);
                console.log(err);
                message.error('Something went wrong');
            })
    }


    return (
        <div className='phantom-form stable-builder'>
            <StAddNew
                initForm={dictForm}
                colSpan={12}
                stopResetForm={true}
                urlEndpoint="/miscellaneous/pageconfig"
                urlData={{ dictName: "StableBuilderQuery" }}
                extraData={{}}
                onCallFinish={({ data }) => {
                    console.log(data);
                    setPageConfigData(data);
                    // setControlTyp('all');
                }}
            />
            {
                pageConfigData && (
                    <div>
                        <div className='stable-builder-btns' style={{ marginTop: 20, display: 'inline-flex', flexWrap: 'wrap', width: '100%' }}>
                            <Button style={{ marginRight: 10 }} ghost={true} type="primary" onClick={() => openModal({ typ: 'edit-tableTitle', data: { ...pageConfigData.config.tableTitle } })}>
                                Table Title
                            </Button>
                            <Button style={{ marginRight: 10 }} ghost={true} type="primary" onClick={() => openModal({ typ: 'edit-tableSubTitle', data: { ...pageConfigData.config.tableSubTitle } })}>
                                Table Sub-Title
                            </Button>
                            <Button style={{ marginRight: 10 }} ghost={true} type="primary" onClick={() => openModal({ typ: 'edit-tableConfig', data: { ...pageConfigData.config.tableConfig } })}>
                                Table Config
                            </Button>
                            <Button style={{ marginRight: 10 }} ghost={true} type="primary" onClick={() => openModal({ typ: 'edit-zenFuncs', data: { ...pageConfigData.config.zenFuncs } })}>
                                Zen Funcs
                            </Button>
                            <Button style={{ marginRight: 10 }} ghost={true} type="primary" onClick={() => openModal({ typ: 'edit-footer', data: { ...pageConfigData.config.footer } })}>
                                Footer Config
                            </Button>
                            <Button style={{ marginRight: 10 }} ghost={true} type="primary" onClick={() => openModal({ typ: 'add-footer-btn' })}>
                                Add Footer Buttons
                            </Button>
                            <Button style={{ marginRight: 10 }} ghost={true} type="primary" onClick={() => openSmodal(zenPop.addRat)}>
                                Add Row Action Buttons (rat)
                            </Button>
                            <Button style={{ marginRight: 10 }} ghost={true} type="primary" onClick={() => openSmodal(zenPop.addHat)}>
                                Add ZenPop (hat)
                            </Button>
                            <Button style={{ marginRight: 10 }} ghost={true} type="primary" onClick={downloadJson}>
                                Download JSON
                            </Button>
                            <Button style={{ marginRight: 10 }} ghost={true} type="primary" onClick={() => openModal({ typ: 'upload-json' })}>
                                Upload JSON
                            </Button>
                            <a className='ant-btn ant-btn-primary ant-btn-background-ghost' target='_blank' href={`/v02/${localStorage.getItem('urlCode')}/stable-preview?_id=${pageConfigData?.config?.pageconfigId}&dictName=${pageConfigData?.config?.dictName}`}>
                                Preview Stable
                            </a>
                        </div>
                        <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} smodalCallback={() => {
                            setPageConfigData(null);
                            dictForm.submit();
                        }} />
                        <div style={{ marginTop: 20 }}>
                            {
                                pageConfigData?.config?.zenFuncs?.headerMultiline && (
                                    <div className='headerMultiline-singleCol-wrapper mb-30'>
                                        <div className="section-header">
                                            <h1 className='section-title'>Header Multi Line Single Col</h1>
                                            <Tooltip title="Add New" color="green">
                                                <Button
                                                    className='add-new-icon'
                                                    icon={<PlusCircleFilled />}
                                                    type="link" onClick={() => openModal({ typ: 'add-headerMultilineSingle' })}>{''}</Button>

                                            </Tooltip>
                                        </div>
                                        <div style={{ display: 'flex', width: '100%', justifyContent: 'center', flexDirection: 'column' }}>
                                            {
                                                pageConfigData?.config?.headerMultiline?.singleCol?.length &&
                                                pageConfigData?.config?.headerMultiline?.singleCol.map((x, i) => (
                                                    <div key={`stable_headerMultilinSingleCol_${i}`} className='block multiline-singleCol zen-preview-control-wrapper'>
                                                        <p style={{ color: 'white' }}>{x.text}</p>
                                                        <div className='control-edit-btns' style={{ display: 'flex', background: 'black' }}>
                                                            <Tooltip title="Edit" color="green">
                                                                <Button
                                                                    style={{ marginRight: 10 }}
                                                                    onClick={() => openModal({
                                                                        typ: 'edit-headerMultilineSingle', data: {
                                                                            ...x,
                                                                            zenPreviewListIndex: i
                                                                        }
                                                                    })}
                                                                    type="link"
                                                                    icon={
                                                                        <EditOutlined style={{ fontSize: 30 }} />
                                                                    }
                                                                >{''}</Button>
                                                            </Tooltip>

                                                            <Tooltip title="Delete" color="red">
                                                                <Button
                                                                    style={{ marginLeft: 10, marginRight: 10 }}
                                                                    onClick={() => deleteSingleCol(i, 'header')}
                                                                    type="link"
                                                                    danger={true}
                                                                    icon={
                                                                        <DeleteOutlined style={{ fontSize: 30 }} />
                                                                    }
                                                                >{''}</Button>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            }
                            <div className='column-wrapper mb-30'>
                                <div className="section-header">
                                    <h1 className='section-title'>Columns</h1>
                                    <Tooltip title="Add New" color="green">
                                        <Button
                                            className='add-new-icon'
                                            icon={<PlusCircleFilled />}
                                            type="link" onClick={() => openModal({ typ: 'add-column' })}>{''}</Button>

                                    </Tooltip>
                                </div>
                                <div style={{ display: 'inline-flex', width: '100%' }}>
                                    {
                                        pageConfigData?.config?.column.map((x, i) => (
                                            <div key={`Stable_Column_${i}`} className='block zen-preview-control-wrapper'>
                                                <p style={{ color: 'white' }}>{x.title}</p>
                                                <div className='control-edit-btns' style={{ display: 'flex', background: 'black' }}>
                                                    <Tooltip title="Edit" color="green">
                                                        <Button
                                                            style={{ marginRight: 10 }}
                                                            onClick={() => openModal({
                                                                typ: 'edit-column', data: {
                                                                    ...x,
                                                                    zenPreviewListIndex: i
                                                                }
                                                            })}
                                                            type="link"
                                                            icon={
                                                                <EditOutlined style={{ fontSize: 30 }} />
                                                            }
                                                        >{''}</Button>
                                                    </Tooltip>

                                                    <Tooltip title="Delete" color="red">
                                                        <Button
                                                            style={{ marginLeft: 10, marginRight: 10 }}
                                                            onClick={() => deleteColumn(i)}
                                                            type="link"
                                                            danger={true}
                                                            icon={
                                                                <DeleteOutlined style={{ fontSize: 30 }} />
                                                            }
                                                        >{''}</Button>
                                                    </Tooltip>
                                                    <p style={{ color: '#52c41a', marginBottom: 0, marginTop: 10, fontSize: 15 }}>{`[${i}]`}</p>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            {
                                pageConfigData?.config?.zenFuncs?.footerMultiline && (
                                    <div className='footerMultiline-singleCol-wrapper mb-30'>
                                        <div className="section-header">
                                            <h1 className='section-title'>Footer Multi Line Single Col</h1>
                                            <Tooltip title="Add New" color="green">
                                                <Button
                                                    className='add-new-icon'
                                                    icon={<PlusCircleFilled />}
                                                    type="link" onClick={() => openModal({ typ: 'add-footerMultilineSingle' })}>{''}</Button>

                                            </Tooltip>
                                        </div>
                                        <div style={{ display: 'flex', width: '100%', justifyContent: 'center', flexDirection: 'column' }}>
                                            {
                                                pageConfigData?.config?.footerMultiline?.singleCol?.length &&
                                                pageConfigData?.config?.footerMultiline?.singleCol?.map((x, i) => (
                                                    <div key={`stable_footerMultilinSingleCol_${i}`} className='block multiline-singleCol zen-preview-control-wrapper'>
                                                        <p style={{ color: 'white' }}>{x.text}</p>
                                                        <div className='control-edit-btns' style={{ display: 'flex', background: 'black' }}>
                                                            <Tooltip title="Edit" color="green">
                                                                <Button
                                                                    style={{ marginRight: 10 }}
                                                                    onClick={() => openModal({
                                                                        typ: 'edit-footerMultilineSingle', data: {
                                                                            ...x,
                                                                            zenPreviewListIndex: i
                                                                        }
                                                                    })}
                                                                    type="link"
                                                                    icon={
                                                                        <EditOutlined style={{ fontSize: 30 }} />
                                                                    }
                                                                >{''}</Button>
                                                            </Tooltip>

                                                            <Tooltip title="Delete" color="red">
                                                                <Button
                                                                    style={{ marginLeft: 10, marginRight: 10 }}
                                                                    onClick={() => deleteSingleCol(i, 'footer')}
                                                                    type="link"
                                                                    danger={true}
                                                                    icon={
                                                                        <DeleteOutlined style={{ fontSize: 30 }} />
                                                                    }
                                                                >{''}</Button>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            }


                        </div>

                    </div>
                )
            }
            <Modal maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={modalData.open} title={modalTitle || "Add Zen Form Control"} onCancel={closeModal}>
                {
                    !elementLoading &&
                    <>
                        <StAddNew
                            dropdownExtraData={{ typ1: 'stable', dictName: pageConfigData?.config?.dictName, pageConfigId: pageConfigData?.config?.pageconfigId }}
                            urlMethod={modalData.typ !== 'upload-json' ? "POST" : "GET"}
                            urlEndpoint={modalData.typ === 'upload-json' ? '/smodal' : '/smodal/zenform'}
                            formName="EditSTable"
                            setSmodalTitle={title => { setModalTitle(title) }}
                            urlData={{
                                ...modalData.data,
                                dictName: stableDictNames[modalData.typ]
                            }}
                            colSpan={24}
                            onFormSubmit={onModalSubmit}
                        />
                        <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                            <Button loading={modalData.loading} htmlType='submit' type="primary" form={'EditSTable'}>Submit</Button>
                        </div>
                    </>
                }
            </Modal>
        </div>
    )
};

export default StableBuilder;